module.exports = __webpack_public_path__ + "assets/img/d2a6a7dd015e60b9b2948d7f06d683fb.png";